import { Pagination } from '../globalTypes'

export enum OfferTemplateId {
    PROPERTY_TEMPLATE_1 = 1,
    PROPERTY_TEMPLATE_2 = 2,
    PROPERTY_TEMPLATE_3 = 3,
    PROJECT_TEMPLATE = 4,
}
export interface OfferPayload {
    agent_id: string | number
    offer_email_settings_group: OfferEmailSettingsGroup[]
    offer_settings_group: OfferSettingsGroup[]
    offer_template: number
    offer_type: string
    offer_locale: string
}

export interface PropertyOfferSettings {
    property_id: string | number
    offer_property_price?: string | null
    offer_property_area?: string | null
    offer_include_ground_plan?: boolean
    offer_include_watermark?: boolean
    offer_include_map?: boolean
    offer_exclude_agent?: boolean
    offer_exclude_header?: boolean
    offer_photo_order?: string
}

export interface ProjectOfferSettings {
    project_id: string | number
}

export type OfferSettingsGroup = PropertyOfferSettings | ProjectOfferSettings

interface Contact {
    contact_id: number
    contact_name: string
    contact_email: string
    internalAppId?: number | null
}

export interface OfferEmailSettingsGroup extends Contact {
    contact_company_collection: Contact[]
    offer_email_title?: string
    offer_email_message?: string
}

export interface OfferCreateResponse {
    id: number
    response: {
        success: string
    }
}

export interface OfferPreviewPayload {
    previewCount: number
    data: {
        agent_id: string | number
        offer_settings_group: OfferSettingsGroup[]
        offer_template: number
        offer_type: string
        offer_locale: string
    }
}

export interface OfferPreviewResponse {
    pdfUrl: string // blob URL
}

export type OfferEntityType = 'project' | 'property'

export interface OfferMessagePayload {
    locale: string
    contactId: number
    agentId: number
    propertyIds?: (number | string)[]
    projectIds?: (number | string)[]
}

export interface OfferMessageResponse {
    title: string
    message: string
}

export interface OfferTemplate {
    id: number
    name: string
    cover: string
    additionalOptions: boolean
}

export interface OfferTemplatesResponse {
    items: OfferTemplate[]
    count: number
    pagination: Pagination
}
